import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { Observable, finalize } from 'rxjs';
import { IGetFacebookPostsData } from '../../Models/IFacebookPost';
import { FacebookService } from '../../Services/facebook.service';
import {faExternalLink} from '@fortawesome/free-solid-svg-icons';
import { HelperFunctions } from '../../../../helpers/HelperFunctions';


@Component({
  selector: 'app-facebook-post-details',
  templateUrl: './facebook-post-details.component.html',
  styleUrls: ['./facebook-post-details.component.scss']
})
export class FacebookPostDetailsComponent implements OnInit {
  @Input() postId?: number;
  postDetails: IGetFacebookPostsData | null = null;
  isLoading = false;
  error: string = '';

  //icons
  faExternalLink = faExternalLink;

  constructor(
    private drawerRef: NzDrawerRef<FacebookPostDetailsComponent>,
    private facebookService: FacebookService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.postId)
      this.loadPostDetails();
    else
      this.error = 'No post ID provided';
  }

  
  loadPostDetails(): void {
    this.isLoading = true;
    this.error = '';
    
    this.facebookService.getPostDetails(this.postId as number)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.cdr.detectChanges(); // Force change detection
        })
      )
      .subscribe({
        next: (response: IGetFacebookPostsData) => {
          this.postDetails = response;
        },
        error: (error) => {
          this.error = 'Failed to load post details. Please try again.';
        }
      });
  }



  formatDatetime(time: string): string {
    return HelperFunctions.formatDatetime(time);
  }
  

  close(): void {
    this.drawerRef.close();
  }
}